export default "__VITE_ASSET__OOTCwDct__"